class TrackingOrder extends HTMLElement {
  API_URL = 'https://backend-shopify-nat-nin.herokuapp.com';
  constructor() {
    super();
    this.orderResult = this.querySelector('#order-result');
    this.form = this.querySelector('form');

    this.form.addEventListener('submit', this.getOrderStatus.bind(this));

    console.log('TrackingOrder constructor');
  }
  getOrderStatus(event) {
    event.preventDefault();

    const customerEmail = this.querySelector('#customerEmail').value;
    const zipCode = this.querySelector('#zipCode').value;

    if (!customerEmail || !zipCode) {
      this.orderResult.innerText = 'Please enter an Order Name and ZIP code.';
      return;
    }

    fetch(`${this.API_URL}/track-order`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customerEmail: customerEmail, zipCode: zipCode })
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          this.orderResultError.classList.remove('hidden');
        } else {
          this.orderResult.classList.remove('hidden');


          let status = data.displayFulfillmentStatus;
          let paid = data.displayFinancialStatus;

          const isLocalPickupOrder = data.shippingAddress === null;

          if (isLocalPickupOrder) {
            this.querySelector('#readyToBePickedUp').classList.remove('hidden');
            this.querySelector('#pickedUp').classList.remove('hidden');
            this.querySelector('#delivered').classList.add('hidden');
            this.querySelector('#shipped').classList.add('hidden');
          } else {
            this.querySelector('#readyToBePickedUp').classList.add('hidden');
            this.querySelector('#pickedUp').classList.add('hidden');
            this.querySelector('#delivered').classList.remove('hidden');
            this.querySelector('#shipped').classList.remove('hidden');
          }

          const steps = [...this.querySelectorAll('.stepper-item')].filter(step => !step.classList.contains('hidden'));
          steps.forEach(step => {
            step.classList.remove('completed');
            step.classList.remove('active');
          });

          if (paid === 'PAID') {
            steps[0].classList.add('completed');
          }

          if (status === 'UNFULFILLED') {
            steps[0].classList.add('completed');
            steps[1].classList.add('completed');
            steps[2].classList.add('active');
          }
          if (status === 'FULFILLED') {
            steps[0].classList.add('completed');
            steps[1].classList.add('completed');
            steps[2].classList.add('completed');
            steps[3].classList.add('active');
          }
          if (status === 'DELIVERED') {
            steps[0].classList.add('completed');
            steps[1].classList.add('completed');
            steps[2].classList.add('completed');
            steps[3].classList.add('completed');
            steps[4].classList.add('active');
          }


          if (data.fulfillments.length > 0) {
            const fulfillment = data.fulfillments[0];
            const trackingUrl = fulfillment.trackingInfo[0].url;

            const trackingNumberElement = this.querySelector('#tracking_url');
            console.log('trackingUrl : ', trackingUrl);
            trackingNumberElement.href = trackingUrl;
            trackingNumberElement.classList.remove('hidden');
          }

          if (data.fulfillments.length === 0) {
            const trackingNumberElement = this.querySelector('#tracking_url');
            trackingNumberElement.classList.add('hidden');
          }
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
    return false;
  }
}

customElements.define("tracking-order", TrackingOrder);
